import { RegisteredDetails } from "../components/RegisteredDetails";
import { RegisterLayout } from "../components/RegisterLayout";
import { BRAND } from "../lib/site";

const Section = ({ n, title, children }) => (
  <section className="py-8 border-b border-white/10" data-testid={`refund-section-${n}`}>
    <div className="grid md:grid-cols-[80px_1fr] gap-4 md:gap-10">
      <span className="font-serif text-3xl text-[#B87333]/40">{n}</span>
      <div>
        <h2 className="font-serif text-2xl md:text-3xl mb-4">{title}</h2>
        <div className="font-body text-[#C9C9C2] leading-relaxed space-y-3 max-w-2xl">{children}</div>
      </div>
    </div>
  </section>
);

export default function Refund() {
  return (
    <RegisterLayout
      kicker="/ Legal"
      title="Returns, Refund & Cancellation Policy"
      subtitle={`How cancellations, returns and refunds work for orders placed with Vinci Inc. Last updated ${new Date().getFullYear()}.`}
    >
      <div className="mt-4">
        <Section n="01" title="Order cancellation">
          <p>You may request cancellation before an order is dispatched. Once dispatched, an order cannot be cancelled but may be handled under the returns process below. To cancel, email <a href={`mailto:${BRAND.email}`} className="text-[#B87333] hover:underline">{BRAND.email}</a> with your order number.</p>
        </Section>
        <Section n="02" title="Returns eligibility">
          <p>As bulk construction materials are made-to-order/commodity goods, returns are accepted only where material is: (a) damaged in transit, (b) materially different from the confirmed specification/grade, or (c) short-supplied. Report such issues within 48 hours of delivery with photographs and the invoice.</p>
        </Section>
        <Section n="03" title="Non-returnable">
          <p>Correctly supplied material that has been used, cut, or altered is not eligible for return. Minor variations within applicable IS tolerances are not considered defects.</p>
        </Section>
        <Section n="04" title="Refund process">
          <p>Approved refunds are made to the original payment method via Razorpay. Once approved, refunds are typically initiated within 5–7 business days; the time to reflect in your account depends on your bank/provider.</p>
        </Section>
        <Section n="05" title="Replacements">
          <p>For damaged or incorrect deliveries, we may offer a replacement or re-dispatch in place of a refund, at the buyer's option and subject to stock availability.</p>
        </Section>
        <Section n="06" title="Contact">
          <RegisteredDetails />
        </Section>
      </div>
    </RegisterLayout>
  );
}
